module.exports = __webpack_public_path__ + "img/right.5914a798.png";